import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import ReactSelect from 'react-select'
import { FormikError } from '../formik_error/FormikError'
import { Times } from './presets/Times'
import styles from './Select.module.scss'

export function Select({
  label,
  formik,
  options,
  field,
  value,
  isRequired = false,
  onChange,
  classes = {},
  style = {},
  ariaLabel,
  isSearchable = true,
  disabled = false,
  placeholder = '',
}: any) {
  const { t } = useTranslation()
  if (options === 'times') options = Times

  const normalizedOptions = options.map((opt) => ({
    ...opt,
    label: opt.label ?? opt.id,
  }))

  const selectedOption = value ? (normalizedOptions.find((opt) => opt.value === value) ?? null) : null

  const hasError = Boolean(formik?.touched[field] && formik?.errors[field])

  const handleChange = (option) => {
    formik?.setFieldValue(field, option?.value ?? null)
    onChange?.(option)
  }

  return (
    <div style={{ ...style.container }} className={clsx(styles['container'], classes.container)}>
      {label && (
        <label className={styles['label']}>
          {label} {isRequired && <span className={styles['required']}>*</span>}
        </label>
      )}
      <ReactSelect
        options={normalizedOptions}
        value={selectedOption}
        onChange={handleChange}
        onBlur={() => formik?.setFieldTouched(field, true)}
        isSearchable={isSearchable}
        isDisabled={disabled}
        placeholder={placeholder || t('form.select.selectOption')}
        noOptionsMessage={() => t('form.select.noOptions')}
        aria-label={ariaLabel || label || 'Select input'}
        unstyled
        classNamePrefix='nv-select'
        classNames={{
          control: () => clsx({ [styles['error-control']]: hasError }, classes.select),
          menu: () => classes.content || '',
        }}
      />
      <FormikError formik={formik} fieldName={field} />
    </div>
  )
}
